// extracted by mini-css-extract-plugin
export default {"inappcard":"inappcard__rK39rR0NpELV","PaddedWrapper":"PaddedWrapper__OzWrXldajczw"};